var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},_vm._l((_vm.sponsors),function(sponsor){return _c('v-col',{key:sponsor.name,staticClass:"mx-12 my-16",attrs:{"align-self":"center","cols":"4","lg":"2","md":"2"}},[_c('a',{attrs:{"href":sponsor.link,"target":"_blank"}},[_c('v-img',{attrs:{"contain":"","src":sponsor.img}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }